export class EmployeeListFileReadException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EmployeeListFileReadException';
  }
}
